import { render, staticRenderFns } from "./Brand.vue?vue&type=template&id=4af3075b&scoped=true&"
import script from "./Brand.vue?vue&type=script&lang=js&"
export * from "./Brand.vue?vue&type=script&lang=js&"
import style0 from "./Brand.vue?vue&type=style&index=0&id=4af3075b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af3075b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4af3075b')) {
      api.createRecord('4af3075b', component.options)
    } else {
      api.reload('4af3075b', component.options)
    }
    module.hot.accept("./Brand.vue?vue&type=template&id=4af3075b&scoped=true&", function () {
      api.rerender('4af3075b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/brand/Brand.vue"
export default component.exports